<template>

    <b-container class="main-section px-0">
        <b-col class="h-100 d-flex px-0">

            <b-container class="pt-3 px-0">
                <b-col class="h-100 py-5 d-flex flex-column">

                    <b-row>
                        <b-col class="text-center">
                            <div class="d-inline-flex">
                                <b-button style="max-width:200px" @click="onNextButtonClicked">Next Sample</b-button>
                                <b-form-checkbox class="ml-5 my-auto" style="max-width:250px" switch v-model="videoStartsAtRandomTime">
                                    Start at random time
                                </b-form-checkbox>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row class="text-center mt-2">
                        <span>Autoplay should work after clicking play the first time</span>
                    </b-row>

                    <b-row class="pt-3 text-center flex-fill">
                        <div class="position-relative">
                            <div id="video-player"></div>
                            <div v-if="!videoLoaded" class="loading-overlay">
                                <div class="my-auto mx-auto">
                                    <circle-10 size="200px" />
                                    <span style="font-size:15pt">E-Digging...</span>
                                </div>
                            </div>
                        </div>
                    </b-row>

                </b-col>

            </b-container>

        </b-col>
    </b-container>

</template>
  
<script>
import YouTubePlayer from 'youtube-player';
import { Circle10 } from 'vue-loading-spinner';

export default {

    name: "Digger",

    components: { Circle10 },

    data() {
        return {
            introVisible: true,
            player: null,
            videoLoaded: false,
            isFirstVideo: true,
            videoStartsAtRandomTime: true
        };
    },

    async mounted() {

        this.player = YouTubePlayer('video-player', {
            height: "100%",
            width: "100%",
            playerVars: {
                'autoplay': 0
            }
        });

        this.player.on("stateChange", event => this.onStateChange(event));
        this.player.on("error", event => this.onError(event));

        await this.loadNextVideo();
    },

    methods: {

        onStartClicked: function () {
            this.introVisible = false;
        },

        onStateChange: async function (e) {

            console.log("State change");
            console.log(e);

            const duration = await this.player.getDuration();

            console.log(`Duration: ${duration}`);

            if (this.videoLoaded || duration <= 0) {
                return;
            }

            if (this.videoStartsAtRandomTime) {

                const seekToPosition = Math.floor(Math.random() * (duration * .9));

                console.log(`Seeking to position ${seekToPosition}`);

                await this.player.seekTo(seekToPosition);
            }

            this.videoLoaded = true;
        },

        async onError(e) {

            console.log("Error");
            console.log(e);

            this.videoLoaded = false;

            await new Promise(resolve => setTimeout(resolve, 1000));
            await this.loadNextVideo();
        },

        onNextButtonClicked: async function () {
            await this.loadNextVideo();
        },

        loadNextVideo: async function () {

            this.videoLoaded = false;

            const nextVideoId = await this.getRandomVideoId();

            this.player.loadVideoById(nextVideoId);
        },

        getRandomVideoId: async function () {

            const apiUrl = process.env.NODE_ENV === "development" ? "http://localhost:7071/api/get-video" : "/api/get-video";
            const apiResponse = await fetch(apiUrl);
            const apiResponseData = await apiResponse.json();

            return apiResponseData.videoId;
        }
    }
};

</script>
  
<style>
.main-section {
    color: white;
    margin-top: 66px;
    height: calc(100vh - 134px);
    width: calc(100vw);
}

.custom-control-input:focus~.custom-control-label::before {
    border-color: #5520E0 !important;
}

.custom-control-input:checked~.custom-control-label::before {
    border-color: #5520E0 !important;
    background-color: #5520E0 !important;
}

.custom-control-input:active~.custom-control-label::before {
    background-color: #5520E0 !important;
    border-color: #5520E0 !important;
}

.custom-control-input:focus:not(:checked)~.custom-control-label::before {
    border-color: #5520E0 !important;
}

.player-container {
    max-width: 100%;
}

.loading-overlay {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: absolute;
    display: grid;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.85);
}

.spinner {
    background: rgba(0, 0, 0, 0.0) !important;
}

.spinner-inner {
    background: rgba(0, 0, 0, 0.0) !important;
}

.loader-xbox {
    background-color: #111111 !important;
    border-top: 3px solid #5520E0 !important;
    outline-width: 1px;
    outline-style: solid;
    outline-color: rgb(58, 58, 58);
}

.loader-xbox:before {
    border-top: 1px solid #5520E0 !important;
}

.loader-xbox:after {
    border-width: 16px !important;
    border-color: rgb(182, 182, 182) !important;
    height: 36px !important;
    width: 36px !important;
    top: 29px !important;
    left: 29px !important;
}
</style>
  